import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoEsctOrganizativa from "../../catalogos/catalogoEstructuraOrganizativa";

export const ActualizarCatgProgramatica = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [activate, setActivate] = useState(false);
  const [msg, setMsg] = useState();
  const [mostrar3, setMostrar3] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tecla, setTecla] = useState();
  const [activo, setActivo] = useState(true);
  const [act, setAct] = useState(false);
  const [act1, setAct1] = useState(true);
  const [act2, setAct2] = useState(true);
  const [act3, setAct3] = useState(true);
  const [act4, setAct4] = useState(true);
  const [activo1, setActivo1] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [uno, setUno] = useState();
  const [dos, setDos] = useState();
  const [tres, setTres] = useState();
  const [cuatro, setCuatro] = useState();
  const [valorto, setValorto] = useState();
  const [cinco, setCinco] = useState();
  const [values, setValues] = useState({
    idcategoriaprogramatica: "",
    descripcion: "",
    categoriaprogramatica: "",
    idcoordinacion: "",
  });
  const [unidad, setUnidad] = useState({
    idcoordinacion: "",
    nombre: "",
    funciones: "",
    iddireccion: "",
    encargado: "",
    esdireccion: "",
    institucion: "",
    firma: "",
    sufijo: "",
    nombredir: "",
    nombrecoor: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtNombre = useRef();
  const txtDescrip = useRef();
  const txtDescripuni = useRef();
  const txtCodigo = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txt5 = useRef();

  const onChange = (event) => {
    let one;
    let doss;
    let tress;
    let cuatros;
    let cincos;
    if (event.target.name === "uno") {
      one = txt1.current.value;
      if (operacion === 2) {
        if (
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) > 0) ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) > 0) ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) === "0") ||
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) === "0")
        ) {
          setAct(true);
          setAct2(false);
          txt2.current.value = "00";
        }
      }
      setUno(one);
      setActivo1(true);
    } else if (event.target.name === "dos") {
      doss = txt2.current.value;
      if (operacion === 2) {
        if (
          (txt2.current.value.substring(0, 1) > 0 &&
            txt2.current.value.substring(1, 2) > 0) ||
          (txt2.current.value.substring(0, 1) === "0" &&
            txt2.current.value.substring(1, 2) > 0) ||
          (txt2.current.value.substring(0, 1) === "0" &&
            txt2.current.value.substring(1, 2) === "0") ||
          (txt2.current.value.substring(0, 1) > 0 &&
            txt2.current.value.substring(1, 2) === "0")
        ) {
          setAct(true);
          setAct2(false);
          txt3.current.value = "00";
        }
      }
      setDos(doss);
    } else if (event.target.name === "tres") {
      tress = txt3.current.value;
      if (operacion === 2) {
        if (
          (txt3.current.value.substring(0, 1) > 0 &&
            txt3.current.value.substring(1, 2) > 0) ||
          (txt3.current.value.substring(0, 1) === "0" &&
            txt3.current.value.substring(1, 2) > 0) ||
          (txt3.current.value.substring(0, 1) === "0" &&
            txt3.current.value.substring(1, 2) === "0") ||
          (txt3.current.value.substring(0, 1) > 0 &&
            txt3.current.value.substring(1, 2) === "0")
        ) {
          setAct1(true);
          setAct3(false);
          txt4.current.value = "00";
        }
      }
      setTres(tress);
    } else if (event.target.name === "cuatro") {
      cuatros = txt4.current.value;
      if (operacion === 2) {
        if (
          (txt4.current.value.substring(0, 1) > 0 &&
            txt4.current.value.substring(1, 2) > 0) ||
          (txt4.current.value.substring(0, 1) === "0" &&
            txt4.current.value.substring(1, 2) > 0) ||
          (txt4.current.value.substring(0, 1) === "0" &&
            txt4.current.value.substring(1, 2) === "0") ||
          (txt4.current.value.substring(0, 1) > 0 &&
            txt4.current.value.substring(1, 2) === "0")
        ) {
          setAct2(true);
          setAct4(false);
        }
      }
      setCuatro(cuatros);
    } else if (event.target.name === "cinco") {
      cincos = txt5.current.value;
      if (operacion === 2) {
        if (
          (txt5.current.value.substring(0, 1) > 0 &&
            txt5.current.value.substring(1, 2) > 0) ||
          (txt5.current.value.substring(0, 1) === "0" &&
            txt5.current.value.substring(1, 2) > 0) ||
          (txt5.current.value.substring(0, 1) === "0" &&
            txt5.current.value.substring(1, 2) === "0") ||
          (txt5.current.value.substring(0, 1) > 0 &&
            txt5.current.value.substring(1, 2) === "0")
        ) {
          setAct3(true);
          setAct4(true);
          setAct(false);
          txtDescrip.current.focus();
        }
      }
      setCinco(cincos);
    }
  };

  const onNext = (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.name === "uno") {
        txt2.current.focus();
      } else if (event.target.name === "dos") {
        txt3.current.focus();
      } else if (event.target.name === "tres") {
        txt4.current.focus();
      } else if (event.target.name === "cuatro") {
        txt5.current.focus();
      } else if (event.target.name === "cinco") {
        txtDescrip.current.focus();
      } else if (event.target.name === "descripcat") {
        txtCodigo.current.focus();
      }
    }
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txt1.current.value.trim() === "" &&
      txt2.current.value === "" &&
      txt3.current.value === "" &&
      txt4.current.value === "" &&
      txt5.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Categoria Programatica no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txt1.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción de la Categoria Programatica no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Unidad Ejecutora",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtDescripuni.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Unidad Ejecutora no Existe o esta Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescripuni.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/actualizarcategoriaprogramatica/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdd.current.value),
      des: txtDescrip.current.value.trim(),
      catpro:
        operacion === 1
          ? uno + dos + tres + cuatro + cinco
          : operacion === 2 && activo1 === true
          ? uno + dos + tres + cuatro + cinco
          : valorto,
      unidadE: parseInt(txtCodigo.current.value),
      efi: idefiscal,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
            SeleccionarEfiscal();
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcategoriaprogramatica: "",
      descripcion: "",
      categoriaprogramatica: "",
      idcoordinacion: "",
    });
    setUnidad({
      idcoordinacion: "",
      nombre: "",
      funciones: "",
      iddireccion: "",
      encargado: "",
      esdireccion: "",
      institucion: "",
      firma: "",
      sufijo: "",
      nombredir: "",
      nombrecoor: "",
    });
    setAct(false);
    setAct1(true);
    setAct2(true);
    setAct3(true);
    setAct4(true);
    setActivate(false);
  };

  const handleCloseCatalogoUni = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoUni = (idcoordinacion, nombrecoor, nombredir) => {
    setMostrar3(false);
    txtCodigo.current.value = idcoordinacion;
    txtDescripuni.current.value = nombrecoor + "(" + nombredir + ")";
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const datosUnidadEjecutora = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtDescripuni.current.value = "";

          if (response.data !== "") {
            txtDescripuni.current.value = response.data.nombrecoor.trim();
            txtCodigo.current.value = response.data.idcoordinacion.trim();

            setActivo(true);

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Error, Unidad Ejecutora no Existe!",
              icono: "error",
            });
            txtCodigo.current.focus();
            unidad.nombrecoor = "";
            unidad.nombredir = "";
            setActivo(true);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarUnidadEjecutora = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosUnidadEjecutora(event.target.value);
      } else {
        txtNombre.current.value = "";
      }
    }
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setUnidad(props.unidad);
          setValues(props.categoria);
          setValorto(props.categoria.categoriaprogramatica);
        } else {
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txt5.current.value = "";
          txtDescripuni.current.value = "";
          setAct(false);
          setAct1(false);
          setAct2(false);
          setAct3(false);
          setAct4(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Categoria Programatica."
              : operacion === 2
              ? "Editar Categoria Programatica."
              : operacion === 3
              ? "Eliminar Categoria Programatica."
              : "Consultar Categoria Programatica."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoEsctOrganizativa
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatUni={handleCloseCatalogoUni}
          onHideAceptaCatUni={handleAceptaCatalogoUni}
        />
        <Dimmer active={activate} />
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="container row m-0">
                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    ref={txtIdd}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={values ? values.idcategoriaprogramatica.trim() : ""}
                    id="inputCedula"
                  />
                </div>
              </div>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto col-sm-11">
                <legend className="float-none m-0 w-auto">
                  Categoria Programatica
                </legend>

                <div className="container row m-0 d-flex justify-content-center">
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sector:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="2"
                      onKeyUp={onNext}
                      name="uno"
                      ref={txt1}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              0,
                              2
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Prog:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act1}
                      maxLength="2"
                      name="dos"
                      ref={txt2}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              2,
                              4
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      SubProg:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act2}
                      maxLength="2"
                      name="tres"
                      ref={txt3}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              4,
                              6
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Proy:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act3}
                      maxLength="2"
                      name="cuatro"
                      ref={txt4}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              6,
                              8
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Act:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={act4}
                      maxLength="2"
                      name="cinco"
                      ref={txt5}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              8,
                              10
                            )
                          : ""
                      }
                      className="form-control text-uppercase col-4"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                </div>
                <div className="input-group py-1 input-group-sm col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Descripción:
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    name="descripcat"
                    onKeyUp={onNext}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtDescrip}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.descripcion.trim() : ""}
                    id="inputDireccion"
                  />
                </div>
              </fieldset>

              <div className="col-md-12 py-2"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Unidad Ejecutora
                </legend>

                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Código:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtCodigo}
                      onKeyUp={validarUnidadEjecutora}
                      className="form-control col-4 px-2"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputCedula"
                      defaultValue={unidad ? unidad.idcoordinacion : ""}
                    />
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={catalogoPer}
                      className="btn btn-sm  btn-info"
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>
                </div>

                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Descripción:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={activo}
                      ref={txtDescripuni}
                      placeholder="Descripción de la Unidad Ejecutora"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={unidad ? unidad.nombrecoor.trim() : ""}
                      id="inputDireccion"
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/presupuesto/modalActualizarCatgProgramarica.js